// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Gsy_U","right":"styles_right__3cQBl"};